import { T } from "../theme";

const sizes = {
  sm: 20,
  md: 32,
  lg: 44,
};

export default function LoadingSpinner({ size = "md", label }) {
  const s = sizes[size] || sizes.md;
  const border = size === "sm" ? 2 : 3;

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: label ? 12 : 0 }}>
      <div
        style={{
          width: s,
          height: s,
          borderRadius: "50%",
          border: `${border}px solid ${T.border}`,
          borderTopColor: T.accent,
          borderRightColor: T.accent,
          animation: "spin 0.8s linear infinite",
        }}
      />
      {label && (
        <p style={{ fontSize: 13, color: T.textLow, fontWeight: 500, fontFamily: T.fontBody }}>
          {label}
        </p>
      )}
    </div>
  );
}
